import React from 'react';
import { useTranslation } from 'react-i18next';
import './PilotCodeOfConductText.css';

const POINT_KEYS = ['pc1', 'pc2', 'pc3', 'pc4', 'pc5', 'pc6', 'pc7'];

export default function PilotCodeOfConductText({ className = '' }) {
  const { t } = useTranslation();

  return (
    <div className={`pilot-code-of-conduct-text ${className}`.trim()}>
      <h3 className="pilot-code-of-conduct-title">{t('easaCharter.pilotCodeTitle')}</h3>
      <ol className="pilot-code-of-conduct-list">
        {POINT_KEYS.map((key) => (
          <li key={key}>{t(`easaCharter.${key}`)}</li>
        ))}
      </ol>
    </div>
  );
}
